export default __webpack_public_path__ + "static/media/shoes8.b62d6468.jpg";